export default function (loginData) {

    return {
        ...loginData
    };
}


// WEBPACK FOOTER //
// ./src/Login/Model/LoginModelFactory.js